import axios from "axios";
import React, { useContext, useEffect, useState } from "react";

import PsContext from "../../context";
import { momentDate, timeTableDayFromNumber } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import SelectRecords from "../selectRecords";
import { Card } from "react-bootstrap";

const PendingAttendanceList = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState([]);

  const [dayOrderListSource, setDayOrderListSource] = useState([]);
  const [dayOrderList, setDayOrderList] = useState([]);
  const [timeTable, setTimeTable] = useState([]);
  const [attendance, setAttendance] = useState([]);

  let dayOrderInDayName = context.settingValue(
    "attendance_dayorder_as_day_name"
  );
  const attendance_hour_per_day = context.settingValue(
    "hour_for_attendance_per_day"
  );

  useEffect(() => {
    if (selectedCourse.course_id) {
      loadDayOrderDates();
      loadDayDeptTimetable();
      listMarkedAttendance();
    }
  }, [selectedCourse]);

  const loadDayDeptTimetable = () => {
    console.log(selectedCourse);
    context.setLoader(true);
    const form = new FormData();
    form.append("course", selectedCourse.course_id);
    form.append("academic_year", selectedCourse.batch);
    form.append("semester", selectedCourse.semester);
    form.append("section", selectedCourse.section);
    axios.post(ServiceUrl.MOB.DEPARTMENT_TIMETABLE, form).then((res) => {
      if (res["data"].status == "1") {
        setTimeTable(res["data"].data);
      }
      context.setLoader(false);
    });
  };

  const loadDayOrderDates = () => {
    console.log(selectedCourse);
    context.setLoader(true);
    const form = new FormData();
    form.append("course", selectedCourse.course_id);
    form.append("academic_year", selectedCourse.batch);
    form.append("semester", selectedCourse.semester);
    form.append("section", selectedCourse.section);
    axios.post(ServiceUrl.MOB.LIST_DAY_ORDERS_BY_BATCHSEM, form).then((res) => {
      if (res["data"].status == "1") {
        setDayOrderListSource(res["data"].data);
        setDayOrderList(res["data"].data);
      }
      context.setLoader(false);
    });
  };

  const listMarkedAttendance = () => {
    console.log(selectedCourse);
    context.setLoader(true);
    const form = new FormData();
    form.append("course", selectedCourse.course_id);
    form.append("academic_year", selectedCourse.batch);
    form.append("semester", selectedCourse.semester);
    form.append("section", selectedCourse.section);
    axios
      .post(ServiceUrl.MOB.LIST_DEPARTMENT_WISE_MARKED_ATTENDANCE, form)
      .then((res) => {
        if (res["data"].status == "1") {
          setAttendance(res["data"].data);
        }
        context.setLoader(false);
      });
  };

  const resetAll = () => {
    setDayOrderListSource([]);
    setDayOrderList([]);
    setSelectedCourse([]);
    setTimeTable([]);
    setAttendance([]);
  };

  const checkAttendanceMarked = (date, dayOrder, hour) => {
    let m = attendance.find(
      (obj) =>
        obj.attendance_date == date &&
        //obj.day_value == dayOrder &&
        obj.hour_value == hour
    );
    return m;
  };

  const listTimeTablesOnDay = (dayORderItem) => {
    let dayOrderTimeTableList = timeTable.filter(
      (item) => item.day_value == dayORderItem.day_order_value
    );

    return dayOrderTimeTableList.map((item, i) => {
      let marked = checkAttendanceMarked(
        dayORderItem.day_order_date,
        item.day_value,
        item.hour_value
      );

      let tr = (
        <tr>
          <td height="22">
            {momentDate(dayORderItem.day_order_date, "DD/MM/YYYY")}
          </td>
          <td>{timeTableDayFromNumber(item.day_value, dayOrderInDayName)}</td>
          <td>
            {item.emp_name} {item.emp_initial}
            <br />
            {item.subject_code} - {item.subject_name}
          </td>

          <td align="center">{item.hour_value}</td>
        </tr>
      );
      //if (status == -1) return tr;
      if (!marked) return tr;
      //if (status == 1 && marked) return tr;
    });
  };

  const getRightActions = () => {
    if (selectedCourse.course_id) {
      return (
        <a onClick={(e) => resetAll()} className="text-underline">
          Reset
        </a>
      );
    }
    return [];
  };
  return (
    <>
      <Header
        title={"Pending Attendance"}
        rightActions={getRightActions()}
        backAction={true}
      />

      <div className="">
        <div className="container-sm py-md-3 ">
          {!selectedCourse.course_id && (
            <Card>
              <Card.Header className="card-header-bg text-uppercase fw-bold">
                Search
              </Card.Header>
              <Card.Body>
                <SelectRecords
                  onSuccess={(d) => setSelectedCourse(d)}
                  currentSem={true}
                  allowdCoursesOnly={true}
                />
              </Card.Body>
            </Card>
          )}

          {selectedCourse.course_id && (
            <Card>
              <Card.Body>
                <table width="100%" align="center">
                  <thead style={{ fontSize: "12px" }}>
                    <tr>
                      <th align="left" width="100">
                        Date
                      </th>
                      <th width="120" align="left">
                        Day Order
                      </th>
                      <th align="left">Details</th>

                      <th width="100" align="center">
                        Hour
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: "12px" }}>
                    {dayOrderList.map((item, i) => {
                      return listTimeTablesOnDay(item);
                    })}
                  </tbody>
                </table>
              </Card.Body>
            </Card>
          )}
        </div>
      </div>
    </>
  );
};
export default PendingAttendanceList;
